import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import ProfileBlock, { ProfileBlockProps } from './ProfileBlock';
import withInteractor from './ProfileBlock.interactor';
import withPresenter from './ProfileBlock.presenter';

export type { ProfileBlockProps };
export default withInteractor(withPresenter(withErrorHandler(ProfileBlock)));
